// Presentation ownership is deliberately not persisted with order tracking.
// A remounted wallet can reconcile an old payment without reviving its modal.
export class DepositNotice {
  private orderId: string | null = null;

  arm(orderId: string) { this.orderId = orderId; }
  end() { this.orderId = null; }

  consume(orderId: string): boolean {
    if (this.orderId !== orderId) return false;
    this.end();
    return true;
  }
}
